import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import MainLayout from 'components/main-layout/MainLayout';
import LayoutContent from 'components/main-layout/LayoutContent';
import NotAuthorizedScreen from 'routes/not-authorized';
import { getUserInfo } from 'utils/auth';

interface IProps {
  isLoading?: boolean;
  error?: unknown;
  children: React.ReactNode;
}

const HourlyAbsences: FC<IProps> = ({ isLoading, error, children }) => {
  const { t } = useTranslation();
  const isHourlyAbsencesActive = getUserInfo().featureHourlyAbsences;

  if (!isHourlyAbsencesActive) {
    return <NotAuthorizedScreen />;
  }

  return (
    <MainLayout title={t('hourlyAbsences.title')}>
      <LayoutContent
        isLoading={isLoading}
        error={error}
      >
        {children}
      </LayoutContent>
    </MainLayout>
  );
};

export default HourlyAbsences;
